import React from "react";
import {IonLoading} from "@ionic/react";
import AuthenticationLocalService from "../../services/storage/localStorage/AuthenticationLocalService";
import RouteService from "../../services/routes/RouteService";
import AuthenticationDistantService from "../../services/storage/distantStorage/AuthenticationDistantService";
import Error from "../utils/alert/error/Error";
import InputUsername from "./InputUsername";
import ValidationButton from "../utils/buttons/ValidationButton";
import './FormLogIn.css';
import { withTranslation, WithTranslation } from 'react-i18next';


/**
 * Component managing the connection of a user
 * @author Alizée Grand
 * @version 1.1
 * @creation 15/04/2021
 * @last_update 11/07/2022
 **/
class FormLogIn extends React.Component<WithTranslation> {

    state = {
        id: "",
        errorVisibility: false,
        errorContent: "",
        isLoadingOpen: false,
    }

    /**
     * Redirects the user to the right place according to his role.
     * If he failed to connect, displays the appropriate errors.
     * @param status (number) - Status of the response returned by the API after the connection attempt
     */
    redirectsUserAfterFormValidation(status: number) {
        if(status === 200){
            const currentUser = AuthenticationLocalService.getCurrentUser();
            this.setState({isLoadingOpen: false});
            if(currentUser!.token) {
                window.location.assign(RouteService.BASIC_URL);
            } else {
                window.location.reload();
            }
        } else if (status === 404 || status === 401 || status === 400) {
            this.setState({errorVisibility: true, errorContent: this.props.t('pages.connection.error.wrongId')});
        } else {
            this.setState({errorVisibility: true, errorContent: this.props.t('pages.connection.error.internalError')});
        }
    }

    render() {

        /**
        * Retrieves from the props the function to access the translation.
        **/
        const getTranslation = this.props.t;

        /**
         * Stores the username in the component when the user enters it
         * @param id
         */
        const onIdChange = (id: string) => {
            this.setState({id: id});
        }

        /**
         * Display or not the loading screen
         * @param {boolean} visibility
         */
        const changeLoadingVisibility = (visibility: boolean) => {
            this.setState({isLoadingOpen: visibility});
        }

        /**
         * Verifies the information entered by the user and makes a connection request to the API.
         * Handles error display and redirects.
         */
        const onValidate = () => {
            changeLoadingVisibility(true);
            if(this.state.id.length > 0){
                AuthenticationDistantService.getToken(this.state.id)
                    .then((status) => {
                        this.redirectsUserAfterFormValidation(status);
                    })
                    .catch(err => {
                        console.log(err);
                        this.setState({errorVisibility: true, errorContent: getTranslation('pages.connection.error.internalError')});
                    })
                    .finally(() => {
                        changeLoadingVisibility(false);
                    })
                ;
            } else {
                this.setState({errorVisibility: true, errorContent: getTranslation('pages.connection.error.wrongId')});
                changeLoadingVisibility(false);
            }
        }

        return (
            <div id="logInInputContainer">
                {
                    this.state.errorVisibility ? (<Error>{this.state.errorContent}</Error>) : ""
                }
                <h1 id="loginTitle">
                    {getTranslation('pages.connection.title')}
                </h1>
                <InputUsername onUsernameChange={onIdChange}/>
                <div id="form-login-validation-button-container">
                    <ValidationButton onClick={onValidate}/>
                </div>
                <IonLoading
                    isOpen={this.state.isLoadingOpen}
                    onDidDismiss={() => this.setState({isLoadingOpen: false})}
                    message={getTranslation('utils.loading.message')}
                    spinner={'bubbles'}
                />
            </div>
        );
    }
}

export default withTranslation()(FormLogIn);
